import Service, { inject as service } from '@ember/service';

export default class SavedMessageCommands extends Service {
  @service api;
  @service shData;
  @service store;

  create(user, {
    title,
    body,
  }) {
    return this.api.post(`users/${user.id}/saved-messages`, {
      jsonData: {
        title,
        body,
      },
    });
  }

  delete(savedMessage) {
    return this.api.delete(`saved-messages/${savedMessage.id}`);
  }

  index(user) {
    return this.api.get(`users/${user.id}/saved-messages`);
  }

  update(savedMessage, {
    title = undefined,
    body = undefined,
  }) {
    const jsonData = {};

    if (title !== undefined) {
      jsonData.title = title;
    }

    if (body !== undefined) {
      jsonData.body = body;
    }

    return this.api.put(`saved-messages/${savedMessage.id}`, { jsonData });
  }
}
